import { useMemo } from 'react';
import { useUserPermissions } from 'entities/user';

export const useAdditionalServicesVisibility = () => {
  const permissions = useUserPermissions();

  return useMemo(() => ({
    buildingRouteFilter: !!permissions.buildingRouteAdditionalServiceSelect,
    stationsFilter: !!permissions.servicePointFilterAdditionalServiceSelect
  }), [permissions]);
};
